module.exports = __webpack_public_path__ + "img/ali_pay_icon.da5951a2.png";